import React, { useState } from "react";

import { Listbox } from "@headlessui/react";
import PropTypes from "prop-types";

import Dropdown from "components/atoms/Dropdown";
import { FiExternalLink } from "components/atoms/Icon/fi/FiExternalLink";
import Img from "components/atoms/Img";
import Link from "components/atoms/LinkRouter";
import Title from "components/atoms/Title";

/** ========== */

const SupportedCountries = ({
  data,
  title,
  description,
  descriptionBottom,
  id,
}) => {
  const [location, setLocation] = useState(data[0]);

  const largestObjLength = data.reduce((a, b) =>
    a.listCountries.length > b.listCountries.length ? a : b
  ).listCountries.length;
  const minHeight = 88 + largestObjLength * 36;

  return (
    <>
      <section
        id={id}
        className=" py-10 text-white lg:py-20 "
        style={{ background: "#011221" }}
      >
        <div className=" relative mb-6 bg-bottom">
          <div className="container relative z-10">
            <Title className="mb-6 text-center text-bbc-30px font-semibold lg:text-bbc-40px">
              {title}
            </Title>
            <p className="mb-6 text-center lg:mb-10">{description}</p>
            <div
              className="relative z-10 hidden  bg-bottom p-16 bg-blend-color lg:block"
              style={{
                background: "#ffffff1a",
                borderRadius: "20px",
              }}
            >
              <div className="row">
                {data.length > 0 &&
                  data.map((item, index) => (
                    <div className="col-4 mb-6 " key={index}>
                      <div className="h-full border-b pb-6">
                        <Title
                          as="h3"
                          text={item.label}
                          className="text-lg font-semibold"
                        />
                      </div>
                    </div>
                  ))}
                {data.length > 0 &&
                  data.map((item, index) => (
                    <div className="col-4" key={index}>
                      <div>
                        {item.listCountries.length > 0 && (
                          <ul className="text-lg">
                            {item.listCountries.map((element, i) => (
                              <li className={`${i > 0 ? "mt-2" : ""}`} key={i}>
                                <Link
                                  href={element.uri}
                                  className="group text-bbc-secondary-300  transition-colors duration-100 hover:text-bbc-yellow-500"
                                >
                                  {element.text}
                                  <FiExternalLink
                                    size={16}
                                    className="relative -left-4 ml-2 inline-block opacity-0 transition-all  duration-200 group-hover:left-0 group-hover:opacity-100 "
                                  />
                                </Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div className="lg:hidden">
              <div
                className="relative  px-3 py-4 bg-blend-color  "
                style={{
                  minHeight,
                  background: "#ffffff1a",
                  borderRadius: "20px",
                }}
              >
                <Dropdown
                  className="relative h-full w-auto text-bbc-brand-700"
                  buttonExtendedClass="font-semibold text-lg leading-7 py-2.5 rounded-[14px] bg-white"
                  labelValue={
                    <div className="truncate text-bbc-yellow-500">
                      {location.label}
                    </div>
                  }
                >
                  <div className="overflow-hidden rounded-xl shadow-md">
                    <div className="max-h-40 overflow-auto bg-white text-lg">
                      {data.map((item, itemIdx) => (
                        <Listbox.Option key={itemIdx} className="list-none">
                          <div
                            className={`flex cursor-pointer items-center gap-x-1 px-4 py-2 ${
                              location.value === item.value
                                ? "bg-bbc-primary text-white"
                                : "hover:bg-bbc-primary hover:bg-opacity-40"
                            }`}
                            onClick={() => setLocation(item)}
                          >
                            <span className="truncate">{item.label}</span>
                          </div>
                        </Listbox.Option>
                      ))}
                    </div>
                  </div>
                </Dropdown>
                {location?.listCountries.length > 0 && (
                  <ul className="mt-4">
                    {location.listCountries.map((element, i) => (
                      <li
                        className={`${i > 0 ? "mt-2" : ""} text-lg font-medium`}
                        key={i}
                        style={{ opacity: "0.9" }}
                      >
                        <Link
                          href={element.uri}
                          className="group text-bbc-secondary-300  transition-colors duration-100 hover:text-bbc-yellow-500"
                        >
                          {element.text}
                          <FiExternalLink
                            size={16}
                            className="relative -left-4 ml-2 inline-block opacity-0 transition-all  duration-200 group-hover:left-0 group-hover:opacity-100 "
                          />
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
          <Img
            src={"/assets/images/common/map-supported-mobile.png"}
            width={375}
            height={446}
            className="absolute left-0 right-0 bottom-0 -z-0 ml-auto mr-auto lg:hidden"
            alt="bg"
          />
          <Img
            src={"/assets/images/common/map-supported.png"}
            width={955}
            height={521}
            className="absolute left-0 right-0 -bottom-3 -z-0 ml-auto mr-auto hidden lg:block "
            alt="bg"
          />
        </div>
        {descriptionBottom}
      </section>
    </>
  );
};

export default SupportedCountries;

SupportedCountries.propTypes = {
  data: PropTypes.array,
};

SupportedCountries.defaultProps = {
  data: [],
};

/** ========== */
